module.exports = __webpack_public_path__ + "static/img/shl_introduce_tab_contact_selected.bc9e176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_introduce_tab_contact_selected.png
// module id = dduM
// module chunks = 5